import React from 'react'
import { StyleSheet } from 'react-native'

import { UploadAvatar } from 'partials/UploadAvatar'

import { Box } from 'widgets/Box'
import { FilledButton } from 'widgets/Button/FilledButton'
import { Text } from 'widgets/Text'

import { useMaxWidth } from 'hooks/useMaxWidth'

type AvatarFormProps = {
  onFinish: () => void
}

export const AvatarForm = ({ onFinish }: AvatarFormProps) => {
  const maxWidth = useMaxWidth()
  const computedStyles = StyleSheet.create({
    textContainer: {
      maxHeight: 150,
      marginTop: maxWidth.width * 0.32,
    },
  })

  return (
    <>
      <Box height={1} align='center' justifyContent='center'>
        <UploadAvatar size={maxWidth.width * 0.5} />
      </Box>

      <Box margin={{ horizontal: 'md' }} style={computedStyles.textContainer}>
        <Text align='center' fontSize='lg' fontWeight='bold' color='white' numberOfLines={2} bold>
          {'Take action and get the\nmost out of your life.'}
        </Text>
      </Box>
      <Box margin={{ top: 'xl', horizontal: 'md' }} padding={{ top: 'xl' }}>
        <FilledButton title='FINISH' onPress={onFinish} />
      </Box>
    </>
  )
}
